import type { Article } from "@/mocks/articles";

interface Props {
  article: Article;
}

export default function ArticleBody({ article }: Props) {
  return (
    <article className="w-full bg-background-100 py-12 md:py-16">
      <div className="w-full px-4 md:px-10 max-w-4xl">
        <div className="mb-8">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-200 text-secondary-800 text-xs font-semibold">
            独家爆料
          </span>
        </div>

        <div className="prose prose-lg max-w-none">
          {article.content.length > 0 ? (
            article.content.map((section, idx) => {
              if (section.type === "heading" && section.text) {
                const HeadingTag = `h${section.level || 2}` as keyof JSX.IntrinsicElements;
                return (
                  <HeadingTag
                    key={idx}
                    className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mt-10 mb-4"
                  >
                    {section.text}
                  </HeadingTag>
                );
              }
              if (section.type === "paragraph" && section.text) {
                return (
                  <p
                    key={idx}
                    className="text-base text-foreground-700 leading-loose mb-6"
                  >
                    {section.text}
                  </p>
                );
              }
              if (section.type === "image" && section.imageUrl) {
                return (
                  <figure key={idx} className="my-8">
                    <div className="rounded-xl overflow-hidden">
                      <img
                        src={section.imageUrl}
                        alt={section.imageAlt || "配图"}
                        className="w-full h-auto object-cover"
                      />
                    </div>
                    {section.imageAlt && (
                      <figcaption className="text-center text-xs text-foreground-400 mt-2">
                        {section.imageAlt}
                      </figcaption>
                    )}
                  </figure>
                );
              }
              return null;
            })
          ) : (
            <p className="text-base text-foreground-500 leading-loose">
              暂无详细内容，请持续关注更新。
            </p>
          )}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <span className="text-sm text-foreground-500">分享到：</span>
              <button className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center cursor-pointer hover:bg-background-300 transition-colors duration-200" aria-label="分享到微博">
                <i className="ri-weibo-line text-foreground-700 w-4 h-4 flex items-center justify-center"></i>
              </button>
              <button className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center cursor-pointer hover:bg-background-300 transition-colors duration-200" aria-label="分享到微信">
                <i className="ri-wechat-line text-foreground-700 w-4 h-4 flex items-center justify-center"></i>
              </button>
              <button className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center cursor-pointer hover:bg-background-300 transition-colors duration-200" aria-label="复制链接">
                <i className="ri-link text-foreground-700 w-4 h-4 flex items-center justify-center"></i>
              </button>
            </div>
            <div className="flex items-center gap-2 text-xs text-foreground-400">
              <span>声明：本文内容来源于网络爆料，不代表本平台立场</span>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}